import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	Grid,
	TextField,
	Select,
	MenuItem,
	Tabs,
	Tab,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import TeamsOnboarding from "../TeamsOnboarding/TeamsOnboarding";
import CompanyInfoPage from "../CompanyInfoPage/CompanyInfoPage";
import NotesPage from "../NotesPage/NotesPage";
import instance from "../../apiServices/instance";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import { useParams } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";

function OnboardingPage() {
	const [tabValue, setTabValue] = useState(0);
	const [companyInfo, setCompanyInfo] = useState();

	const { id } = useParams();

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue);
	};

	async function fetchCompanyData() {
		try {
			const response = await instance.get(`/api/company-info/${id}`); // get this company code from search company api
			const companyData = response?.data?.data;

			setCompanyInfo({
				...companyInfo,
				companyName: companyData?.companyName,
				companyHouseNo: companyData?.companiesHouseNumber,
				registrationAddress: companyData?.registeredAddress,
				confirmationStatementDate:
					companyData?.Deadlines?.confirmationStatementDate,
				teamDetails: companyData.teamDetails,
				noteDetails: companyData.notes,
			});
		} catch (error) {
			console.log("Error in fetching company data: ", error);
		}
	}

	useEffect(() => {
		fetchCompanyData();
		// fetchTeamData();
	}, []);

	return (
		<Box
			display='flex'
			sx={{
				height: "100vh",
				backgroundColor: "#F6F5F8",
				color: "#2F2D3B",
			}}>
			<Box sx={{ flexGrow: 1 }}>
				<Sidebar />
			</Box>
			<Box component='main' sx={{ flexGrow: 1, width: "85%" }}>
				{/* Main content grid */}
				<Grid container>
					{/* Left column - Company details */}
					<Grid
						item
						xs={3}
						sx={{
							background: "white",
							p: 3,
							height: "100vh",
							borderRight: "1px solid #e0e0e0",
						}}>
						<Typography
							variant='h6'
							sx={{ fontWeight: "bold", mb: 3, color: "black" }}>
							Rise Group Services Limited
						</Typography>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								Status
							</Typography>
							<Select
								fullWidth
								defaultValue='active'
								size='small'
								sx={{
									background: "#f5f5f8",
									borderRadius: 1,
									"& .MuiSelect-icon": {
										background: "#D9C2F2",
										padding: "1px",
										borderRadius: "4px",
										height: "95%",
										width: "25px",
										right: "1px",
										top: "50%",
										transform: "translateY(-50%)",
										border: "1px solid black",
									},
								}}>
								<MenuItem value='active'>Active</MenuItem>
								<MenuItem value='inactive'>Inactive</MenuItem>
							</Select>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{
									mb: 1,
									display: "flex",
									justifyContent: "space-between",
									color: "black",
									fontWeight: 500,
								}}>
								Companies House Number
								<LaunchRoundedIcon
									fontSize='small'
									sx={{ color: "blue" }}
								/>
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								value={companyInfo?.companyHouseNo}
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								Industry
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								UTR
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								VAT Number
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								PAYE Reference
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								Office Reference
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{ mb: 1, color: "black", fontWeight: 500 }}>
								Payroll Password
							</Typography>
							<TextField
								fullWidth
								id='standard-read-only-input'
								//   label="Read Only"
								//   defaultValue="Hello World"
								variant='standard'
								InputProps={{
									readOnly: true,
								}}
							/>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{
									mb: 1,
									display: "flex",
									justifyContent: "space-between",
									color: "black",
									fontWeight: 500,
								}}>
								Accounting Software
								{/* <EditIcon fontSize="small" color="primary" /> */}
							</Typography>
							<Select
								fullWidth
								defaultValue=''
								size='small'
								sx={{
									background: "#f5f5f8",
									borderRadius: 1,
									"& .MuiSelect-icon": {
										background: "#D9C2F2",
										padding: "1px",
										borderRadius: "4px",
										height: "95%",
										width: "25px",
										right: "1px",
										top: "50%",
										transform: "translateY(-50%)",
										border: "1px solid black",
									},
								}}>
								<MenuItem value=''>
									<em>None</em>
								</MenuItem>
								<MenuItem value='xero'>Xero</MenuItem>
								<MenuItem value='quickbooks'>
									QuickBooks
								</MenuItem>
								<MenuItem value='sage'>Sage</MenuItem>
							</Select>
						</Box>

						<Box sx={{ mb: 3 }}>
							<Typography
								variant='body2'
								color='textSecondary'
								sx={{
									mb: 1,
									display: "flex",
									justifyContent: "space-between",
									color: "black",
									fontWeight: 500,
								}}>
								Invoice Management Software
								{/* <EditIcon fontSize="small" color="primary" /> */}
							</Typography>
							<Select
								fullWidth
								defaultValue=''
								size='small'
								sx={{
									background: "#f5f5f8",
									borderRadius: 1,
									"& .MuiSelect-icon": {
										background: "#D9C2F2",
										padding: "1px",
										borderRadius: "4px",
										height: "95%",
										width: "25px",
										right: "1px",
										top: "50%",
										transform: "translateY(-50%)",
										border: "1px solid black",
									},
								}}>
								<MenuItem value=''>
									<em>None</em>
								</MenuItem>
								<MenuItem value='xero'>Xero</MenuItem>
								<MenuItem value='quickbooks'>
									QuickBooks
								</MenuItem>
								<MenuItem value='other'>Other</MenuItem>
							</Select>
						</Box>
					</Grid>

					{/* Right column - Team details */}
					<Grid item xs={9} sx={{ p: 3 }}>
						{/* Tabs */}
						{/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Team" />
              <Tab label="Company Info" />
              <Tab label="Notes" />
              <Tab label="Internal" />
            </Tabs>
          </Box> */}
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={tabValue}
								onChange={handleTabChange}
								textColor='inherit'
								TabIndicatorProps={{
									style: {
										backgroundColor: "blue",
										height: 3,
									},
								}} // Purple underline
							>
								<Tab
									label='Team'
									sx={{
										fontWeight:
											tabValue === 0 ? "bold" : "bold",
										fontSize: "18px",
										color: "black",
										// color: tabValue === 0 ? "black" : "gray",
										// opacity: tabValue === 0 ? 1 : 0.6,
										textTransform: "none",
										mr: 5,
									}}
								/>
								<Tab
									label='Company Info'
									sx={{
										fontWeight:
											tabValue === 1 ? "bold" : "bold",
										fontSize: "18px",
										color: "black",
										// color: tabValue === 1 ? "black" : "gray",
										// opacity: tabValue === 1 ? 1 : 0.6,
										textTransform: "none",
										mr: 5,
									}}
								/>
								<Tab
									label='Notes'
									sx={{
										fontWeight:
											tabValue === 2 ? "bold" : "bold",
										fontSize: "18px",
										color: "black",
										// color: tabValue === 2 ? "black" : "gray",
										// opacity: tabValue === 2 ? 1 : 0.6,
										textTransform: "none",
										mr: 5,
									}}
								/>
								<Tab
									label='Internal'
									sx={{
										fontWeight:
											tabValue === 3 ? "bold" : "bold",
										fontSize: "18px",
										color: "black",
										// color: tabValue === 3 ? "black" : "gray",
										// opacity: tabValue === 3 ? 1 : 0.6,
										textTransform: "none",
									}}
								/>
							</Tabs>
						</Box>

						{/* teams-page */}
						{tabValue === 0 && companyInfo && (
							<TeamsOnboarding
								teamDetails={companyInfo.teamDetails}
								setCompanyInfo={setCompanyInfo}
							/>
						)}
						{tabValue === 1 && companyInfo && (
							<CompanyInfoPage companyInfo={companyInfo} />
						)}
						{tabValue === 2 && companyInfo && (
							<NotesPage
								noteDetails={companyInfo.noteDetails}
								setCompanyInfo={setCompanyInfo}
							/>
						)}
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}

export default OnboardingPage;
